"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Render = exports.RenderBase = void 0;
var react_1 = __importDefault(require("react"));
var tiny_emitter_1 = require("tiny-emitter");
var rendererBackend_1 = __importDefault(require("./rendererBackend"));
exports.RenderBase = function (element) {
    return rendererBackend_1.default.updateContainer(element, rendererBackend_1.default.createContainer({}, 0, false, null), null, function () { });
};
var RenderApp = function (props) {
    var _a = react_1.default.useState(false), isStopped = _a[0], setIsStopped = _a[1];
    react_1.default.useEffect(function () {
        props.emitter.on("stop", function () { return setIsStopped(true); });
        props.emitter.on("continue", function () { return setIsStopped(false); });
    }, []);
    return isStopped ? react_1.default.createElement(react_1.default.Fragment, null) : props.children;
};
exports.Render = function (element) {
    var emitter = new tiny_emitter_1.TinyEmitter();
    exports.RenderBase(react_1.default.createElement(RenderApp, { emitter: emitter }, element));
    return {
        stop: function () { return emitter.emit("stop"); },
        continue: function () { return emitter.emit("continue"); },
    };
};
